import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { style: {"float":"left"} }
const _hoisted_3 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_4 = { style: {"float":"left"} }
const _hoisted_5 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_6 = { class: "d-flex pt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Iniciar ")

import { Form } from "vee-validate";
import { ref } from "vue";
import { AuthModule } from "@/store/modules/Auth";
import Select from "@/components/Inputs/Select.vue";
import { schemaStartTicketAnyInterface } from "@/store/schemas/ticket.shema";
import type {
	ModalSidebarState as ModalState,
	Options,
} from "@/types/components";
import axios from "axios";
import { env } from "@/config";
import { socket } from "@/main";
import { InterfaceId, InterfacesName } from "@/types/tickets";
// axios client
interface IClientView {
	_id: string;
	name: string;
	company?: string;
	channels: any[];
}

interface IChannelView {
	_id: string;
	name: string;
	interface: InterfacesName;
}

// emits

export default /*#__PURE__*/_defineComponent({
  emits: ["changeModalStartTicket"],
  setup(__props, { emit: emits }: { emit: ({
	(e: "changeModalStartTicket", t: ModalState): void;
}), expose: any, slots: any, attrs: any }) {

const backendApi = axios.create({ baseURL: env.OmniUrl });

// Interfaces


// State data
const model = ref({
	client: "",
	channel: "",
});
const loading = ref(false);
const clientOptions = ref<Options<IClientView>[]>([]);
const channelOptions = ref<Options<IChannelView>[]>([]);
// Methods
async function onSubmit(e: any) {
	socket.emit("CREATE_TICKET", {
		token: AuthModule.token,
		client: e.client,
		channel: e.channel,
	});
	emits("changeModalStartTicket", { show: false });
}

function handleSearch(query: string) {
	loading.value = true;
	backendApi
		.get("/client/search_profiles_agent", {
			params: { filter: query, limit: 120 },
			auth: AuthModule.Admin,
		})
		.then(response => {
			clientOptions.value = response.data.profiles.map((user: any) => ({
				value: {
					_id: user._id,
					name: user.customer.name,
					company: user.company_name,
					channels: user.channels,
				},
				label: user.customer.name,
			}));
		})
		.catch(err => console.log(err, "ERROR"))
		.finally(() => {
			loading.value = false;
		});
}

function handleChange(item: IClientView) {
	channelOptions.value = item.channels.map((channel: any) => ({
		value: {
			_id: channel.channel._id,
			name: channel.channel.name,
			interface: InterfacesName[channel.channel.interface as InterfaceId],
		},
		label: channel.channel.name,
	}));

	channelOptions.value = channelOptions.value.filter(
		(channel, index, self) =>
			index === self.findIndex(c => c.value._id === channel.value._id)
	);
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(_unref(Form), {
    "validation-schema": _unref(schemaStartTicketAnyInterface)(),
    onSubmit: _cache[1] || (_cache[1] = (e) => onSubmit(e))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Select, {
          name: "client",
          label: "Busque un cliente para iniciar conversación",
          placeholder: "Busque un cliente",
          "label-classes": "text-muted h5 font-weight-normal",
          "addon-left-icon": "fas fa-users",
          value: model.value.client,
          "select-options": {
					options: clientOptions.value,
					noDataText: 'Sin clientes',
					valueKey: '_id',
					multiple: false,
				},
          alternative: "",
          remote: "",
          "remote-method": handleSearch,
          loading: loading.value
        }, {
          default: _withCtx((slotProp) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((slotProp.options as Options<IClientView>[]), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value?._id,
                label: item.value?.name,
                value: item.value?._id,
                tabindex: "1",
                onClick: ($event: any) => (handleChange(item.value))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.value?.name), 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(item.value?.company), 1)
                ]),
                _: 2
              }, 1032, ["label", "value", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "select-options", "loading"]),
        (channelOptions.value.length > 0)
          ? (_openBlock(), _createBlock(Select, {
              key: 0,
              name: "channel",
              label: "Elegir un canal para iniciar conversación",
              placeholder: "Seleccione un canal",
              "label-classes": "text-muted h5 font-weight-normal",
              "addon-left-icon": "fas fa-envelope",
              value: model.value.channel,
              "select-options": {
					options: channelOptions.value,
					noDataText: 'Sin canales',
					valueKey: '_id',
					multiple: false,
				},
              alternative: ""
            }, {
              default: _withCtx((slotProp) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((slotProp.options as Options<IChannelView>[]), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value?._id,
                    label: item.value?.name,
                    value: item.value?._id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.value?.name), 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.value?.interface), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "select-options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_base_button, {
            type: "link",
            onClick: _cache[0] || (_cache[0] = () => emits('changeModalStartTicket', { show: false }))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, {
            type: "primary",
            "native-type": "submit",
            class: "ml-auto"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}
}

})